import { Character, CharacterGetRes, CharacterStats } from '@/types/character'
import { SimulatorGameProject } from '@/types/simulatorGame'
import { User } from '@/types/user'

const getCoverUrl = (item: SimulatorGameProject) => {
  const cover = item.assets?.cover
  if (typeof cover === 'string') return cover
  return (
    cover?.content_url || cover?.url || item.face_url || item.image_url || ''
  )
}

export type SimulatorGameHomeCard = CharacterGetRes & {
  item_type: 'game'
  game_id: string
  project_id: string
  publish_version?: string | number | null
  publish_announcement?: string | null
  version_change?: boolean
}

export const adaptSimulatorGameToHomeCard = (
  item: SimulatorGameProject
): SimulatorGameHomeCard => {
  const gameId = String(item.game_id || item.project_id)
  const coverUrl = getCoverUrl(item)
  const creator = {
    user_id: String(item.creator?.user_id || item.user_id || ''),
    nickname: item.creator?.nickname || '',
    avatar_url: item.creator?.avatar_url || item.creator?.avatar || '',
    avatar: item.creator?.avatar || '',
  } as User

  const character = {
    created_at: 0,
    updated_at: 0,
    character_id: gameId,
    creator_id: creator.user_id || String(item.user_id || ''),
    nickname: item.name,
    gender: 'other',
    image_url: coverUrl,
    image: coverUrl,
    video: '',
    video_url: '',
    face_url: coverUrl,
    face: coverUrl,
    animated_image_url: coverUrl,
    animated_image: coverUrl,
    pc_image_url: coverUrl,
    pc_image: coverUrl,
    introduction: item.introduction || '',
    greeting: item.introduction || '',
    nsfw: !!item.nsfw,
    is_public: item.is_public ?? true,
    show_background: false,
    tag_ids: [],
    tags: [],
    voice_param: {
      voices: [],
      weights: [],
      speed: 1,
      pitch: 0,
    },
    badges: null,
    default_greet_voice: '',
    dialog_style: [],
    img_primary_color: '',
    is_chatted: false,
    is_translated: false,
    content_type: 0,
    character_type: 9,
    total_messages: item.stats?.studio_chat_count || 0,
    total_plots: 0,
    minor_review_status: 'approved',
  } as Character

  const stats = {
    character_id: gameId,
    connection_count: item.stats?.connection_count || 0,
    total_messages: item.stats?.studio_chat_count || 0,
    total_plots: 0,
    public_plots: 0,
    sfw_plots: 0,
  } as CharacterStats

  return {
    item_type: 'game',
    game_id: gameId,
    project_id: gameId,
    publish_version: item.publish_version,
    publish_announcement: item.publish_announcement,
    version_change: item.version_change,
    character,
    stats,
    creator,
  }
}
